import React from 'react';
import GeneralRadiobuttonOn from '../../images/general-radiobutton-on.svg';
import GeneralRadiobuttonOff from '../../images/general-radiobutton-off.svg';
import i18n from '../../utils/i18n';

const Selector = ({
	labelTop,
	labelBottom,
	selected,
	borderRadius = '0px',
	borderSides = { top: true, right: true, bottom: true, left: true },
	onToggle,
}) => {
	const borderStyle = (side) =>
		borderSides[side] ? '1px solid #d1d5db' : 'none';
	const isMobile = window.innerWidth <= 480;
	return (
		<div
			onClick={onToggle}
			style={{
				marginRight: isMobile ? '0px' : '16px',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				borderTop: borderStyle('top'),
				borderRight: borderStyle('right'),
				borderBottom: borderStyle('bottom'),
				borderLeft: borderStyle('left'),
				borderRadius: borderRadius,
				padding: '8px 16px',
				width: isMobile ? 'auto' : '251px',
				height: '66px',
				cursor: 'pointer',
				transition: 'border-color 0.3s ease',
				backgroundColor: selected ? '#fafcfe' : 'transparent',
			}}>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					width: '100%',
					marginBottom: '4px',
				}}>
				<div
					style={{
						fontSize: '12px',
						color: '#6b7280',
						flexGrow: 1,
					}}>
					{labelTop}
				</div>
				<img
					src={selected ? GeneralRadiobuttonOn : GeneralRadiobuttonOff}
					alt={
						selected
							? i18n.t('general.selected')
							: i18n.t('general.notSelected')
					}
					style={{
						width: '13px',
						height: '13px',
					}}
				/>
			</div>
			<div
				style={{
					fontSize: '14px',
					fontWeight: 'bold',
					color: '#111827',
					textAlign: 'left',
					width: '100%',
				}}>
				{labelBottom}
			</div>
		</div>
	);
};

export default Selector;
